import { IListItem, IReferralConfig } from '@nkr/models/index'
import { IValidation } from './validation'
import { Col, ControlLabel, FormControl, FormGroup, Label, Panel, Radio } from 'react-bootstrap';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    data: IReferralConfig,
    validation: IValidation,
    dirty: boolean,
    svVideoList: IListItem[],
    dcGroups: IListItem[],
    onRadioChange: (e: React.FormEvent<Radio & HTMLInputElement>) => void,
    onDataChange: (e: React.FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => void
}

const AdminOnly = (props: IProps) => {
    const { app: { site } } = useAppHookContext();

    return (
        <Panel style={{ backgroundColor: 'whitesmoke' }}>
            <Panel.Heading>Admin Only</Panel.Heading>
            <Panel.Body>
                <FormGroup validationState={props.dirty && !props.validation.isRegistrationEnabled ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Is Registration Enabled?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='isRegistrationEnabled' value={1} checked={props.data.isRegistrationEnabled != null ? props.data.isRegistrationEnabled : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='isRegistrationEnabled' value={0} checked={props.data.isRegistrationEnabled != null ? !props.data.isRegistrationEnabled : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                {site.organType == OrganType.Kidney && (
                    <>
                        <FormGroup validationState={props.dirty && !props.validation.useAdpDefaults ? 'error' : null}>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>Use Voucher Education Module?<br />
                                <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                                    PL DASH
                                </Label>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Radio inline name='useAdpDefaults' value={1} checked={props.data.useAdpDefaults != null ? props.data.useAdpDefaults : false} onChange={props.onRadioChange}>Yes</Radio>
                                <Radio inline name='useAdpDefaults' value={0} checked={props.data.useAdpDefaults != null ? !props.data.useAdpDefaults : false} onChange={props.onRadioChange}>No</Radio>
                            </Col>
                        </FormGroup>


                        <FormGroup validationState={props.dirty && !props.validation.offerDonorConnect ? 'error' : null}>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>Offer Donor Mentor to Registrants?<br />
                                <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                                    PL DASH
                                </Label>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Radio inline name='offerDonorConnect' value={1} checked={props.data.offerDonorConnect != null ? props.data.offerDonorConnect : false} onChange={props.onRadioChange}>Yes</Radio>
                                <Radio inline name='offerDonorConnect' value={0} checked={props.data.offerDonorConnect != null ? !props.data.offerDonorConnect : false} onChange={props.onRadioChange}>No</Radio>
                            </Col>
                        </FormGroup>
                    </>
                )}

                <FormGroup validationState={props.dirty && !props.validation.isDonorConnectLiverEnabled ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Offer Donor Mentor to Liver Registrants?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='isDonorConnectLiverEnabled' value={1} checked={props.data.isDonorConnectLiverEnabled != null ? props.data.isDonorConnectLiverEnabled : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='isDonorConnectLiverEnabled' value={0} checked={props.data.isDonorConnectLiverEnabled != null ? !props.data.isDonorConnectLiverEnabled : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Assign Mentors from which Donor Mentor Group?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <FormControl
                            componentClass='select'
                            name='donorConnectGroup'
                            id="donorConnectGroup"
                            value={props.data.donorConnectGroup}
                            onChange={props.onDataChange}
                        >
                            {props.dcGroups.map(i =>
                                <option key={'dcGrp-' + i.id} value={i.id}>{i.description}</option>
                            )}
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.dashUsesFiveStar ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>When available, use 5-star surveys?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='dashUsesFiveStar' value={1} checked={props.data.dashUsesFiveStar != null ? props.data.dashUsesFiveStar : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='dashUsesFiveStar' value={0} checked={props.data.dashUsesFiveStar != null ? !props.data.dashUsesFiveStar : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                <FormGroup validationState={props.dirty && !props.validation.isDonorConnectNegC ? 'error' : null}>
                    <Col xs={12} lg={6} componentClass={ControlLabel}>Use Negative Consent for Donor Mentor?<br />
                        <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                            PL DASH
                        </Label>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Radio inline name='isDonorConnectNegC' value={1} checked={props.data.isDonorConnectNegC != null ? props.data.isDonorConnectNegC : false} onChange={props.onRadioChange}>Yes</Radio>
                        <Radio inline name='isDonorConnectNegC' value={0} checked={props.data.isDonorConnectNegC != null ? !props.data.isDonorConnectNegC : false} onChange={props.onRadioChange}>No</Radio>
                    </Col>
                </FormGroup>

                {site.organType == OrganType.Kidney && (
                    <>
                        <FormGroup validationState={props.dirty && !props.validation.isFamilyVoucherLinkOption ? 'error' : null}>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>Show Family Voucher Video Link in DASH?<br />
                                <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                                    PL DASH
                            </Label>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Radio inline name='isFamilyVoucherLinkOption' value={1} checked={props.data.isFamilyVoucherLinkOption != null ? props.data.isFamilyVoucherLinkOption : false} onChange={props.onRadioChange}>Yes</Radio>
                                <Radio inline name='isFamilyVoucherLinkOption' value={0} checked={props.data.isFamilyVoucherLinkOption != null ? !props.data.isFamilyVoucherLinkOption : false} onChange={props.onRadioChange}>No</Radio>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.isStandardVoucherLinkOption ? 'error' : null}>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>Show Standard Voucher Video Link in DASH?<br />
                                <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                                    PL DASH
                            </Label>
                            </Col>
                            <Col xs={12} lg={6}>
                                <FormControl
                                    componentClass='select'
                                    name='isStandardVoucherLinkOption'
                                    id="isStandardVoucherLinkOption"
                                    value={props.data.isStandardVoucherLinkOption}
                                    onChange={props.onDataChange}
                                >
                                    {props.svVideoList.map(i =>
                                        <option key={'svVid-' + i.id} value={i.id}>{i.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.referDonorToNkr ? 'error' : null}>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>Is Universal DASH Participant?<br />
                                <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                                    PL DASH
                                </Label>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Radio inline name='referDonorToNkr' value={1} checked={props.data.referDonorToNkr != null ? props.data.referDonorToNkr : false} onChange={props.onRadioChange}>Yes</Radio>
                                <Radio inline name='referDonorToNkr' value={0} checked={props.data.referDonorToNkr != null ? !props.data.referDonorToNkr : false} onChange={props.onRadioChange}>No</Radio>
                            </Col>
                        </FormGroup>

                        <FormGroup validationState={props.dirty && !props.validation.offerRuleOutTransfer ? 'error' : null}>
                            <Col xs={12} lg={6} componentClass={ControlLabel}>Offer NKR Network to ruled out donors?<br />
                                <Label bsStyle="warning" title="This only applies to Private-Label DASH sites">
                                    PL DASH
                                </Label>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Radio inline name='offerRuleOutTransfer' value={1} checked={props.data.offerRuleOutTransfer != null ? props.data.offerRuleOutTransfer : false} onChange={props.onRadioChange}>Yes</Radio>
                                <Radio inline name='offerRuleOutTransfer' value={0} checked={props.data.offerRuleOutTransfer != null ? !props.data.offerRuleOutTransfer : false} onChange={props.onRadioChange}>No</Radio>
                            </Col>
                        </FormGroup>
                    </>
                )}
            </Panel.Body>
        </Panel>
    );
}

export default AdminOnly;